import 'whatwg-fetch'
import { List } from 'immutable'
import {
  Action,
  AsyncState,
  Fun,
  mk_pair,
  none,
  Option,
  Pair,
  unloadedAsyncState,
  Widget,
} from 'widgets-for-react'

import { get_page, InitPagesStates, PublicSite_CustomPageData, get_options } from './public_site/application.mod'
import { Block } from './wordpress/types_and_parser/standard_blocks.gen'
import { blocks_renderer } from './public_site/blocks/renderer.mod'
import { Breadcrumb } from './wordpress/types_and_parser/extra_types.mod'
import { CustomBlockData } from './public_site/blocks/custom_blocks/types.mod'
import { ExtraImages } from './public_site/utils/extra_images.mod'
import { PageTemplateState } from './cms/state/types.gen'
import { ParsedNode } from './wordpress/types_and_parser/types.ext.gen'
import { CustomPagesState } from './public_site/custom_pages/types.mod'
import { TemplateState } from './cms/page/types.gen'
import { CustomBlock } from './wordpress/types_and_parser/custom_blocks.mod'
import { WordPress } from './wordpress/wordpress_api'
import { CookiebarState } from './cms/blocks/widgets/cookiebar/cookiebar.types'
import { make_cookie_state_zero as make_app_cookie_state_zero } from './cms/blocks/widgets/cookiebar/cookiebar.widget'

export type HeaderState = {
  menu_header: HeaderMenus
  menu: 'closed' | 'open'
  contactbar: 'closed' | 'open'
  lang: 'closed' | 'open'
  showSearchBar: boolean
  searchValue: string
  hoveredItem?: WordPress.MenuItem
}

export type HeaderMenus = {
  breadcrumb: AsyncState<List<{}>>
}

export type FooterState = {
  menu_footer: FooterMenus
}

export type FooterMenus = {

}

export type BrowserState = {
  viewport: 'mobile' | 'tablet' | 'desktop' | 'large'
}

export type OptionsState = AsyncState<WordPress.OptionsResponse>

export type PublicSiteState = {
  header: HeaderState;
  cookiebar: CookiebarState;
  footer: FooterState;
  browser: BrowserState;
  options: OptionsState;
  heroColor: string;
} & PageTemplateState<
  CustomBlockData,
  CustomBlock,
  Block,
  ExtraImages,
  PublicSite_CustomPageData,
any // change this to PublicSiteState when circular reference is supported in TS 
> &
  CustomPagesState;


export const defaultPage: ContentType = x => x;

export type ContentType = (
  placeholder: Widget<
    Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
  >
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>

let initPagesStates = InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>())

export const emptyAppState = (page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>): PublicSiteState =>
({
  ...initPagesStates,
  page: {
    ...initPagesStates.page,
    get_page: get_page,
    display: page(mk_pair(List(), none()))
  },
  browser: {
    viewport: 'desktop'
  },
  header: {
    menu: 'closed',
    contactbar: 'closed',
    menu_header: {
      breadcrumb: unloadedAsyncState()
    },
    showSearchBar: false,
    searchValue: ''
  },
  cookiebar: make_app_cookie_state_zero(),
  footer: {
    menu_footer: {
    }
  },
  options: get_options('global-settings')
} as PublicSiteState)
